import React from 'react';
import { alpha } from '@mui/material/styles';
import { ToggleButton, ToggleButtonGroup, Divider } from '@mui/material';
import MDBox from 'components/MDBox';
import MDTypography from 'components/MDTypography';
import MDInput from 'components/MDInput';
import { moneyTRY, numOr0 } from './ui';

export function OtherPaymentStep({
  theme,
  styles,
  currencyLabel,
  title = 'Ödeme Açıklaması',
  subtitle = 'Örn: Mat / su / ek ders / ürün satışı',
  amountTitle = 'Tutar',
  amountSubtitle,
  previewLabel = 'Önizleme',
  hideMethod = false,
  otherMethod,
  setOtherMethod,
  otherDesc,
  setOtherDesc,
  otherAmountTry,
  setOtherAmountTry,
  error = '',
}) {
  const { orange } = styles;
  const amount = numOr0(otherAmountTry);

  return (
    <MDBox
      sx={{
        p: 1.75,
        borderRadius: '18px',
        border: `1px solid ${alpha(orange, 0.25)}`,
        background: `linear-gradient(135deg, ${alpha(orange, 0.1)}, ${alpha(
          theme.palette.background.paper,
          0.9
        )})`,
        display: 'grid',
        gap: 1.25,
      }}
    >
      <MDBox>
        <MDTypography fontWeight="bold">{title}</MDTypography>
        <MDTypography variant="caption" sx={{ color: 'text.secondary' }}>
          {subtitle}
        </MDTypography>
      </MDBox>

      <MDInput
        value={otherDesc}
        onChange={(e) => setOtherDesc(e.target.value)}
        placeholder="Açıklama yaz..."
        fullWidth
      />

      <MDBox mt={0.5}>
        <MDTypography fontWeight="bold">{amountTitle}</MDTypography>
        <MDTypography variant="caption" sx={{ color: 'text.secondary' }}>
          {amountSubtitle || `Tahsil edilecek tutarı gir (${currencyLabel})`}
        </MDTypography>
      </MDBox>

      {!hideMethod ? (
        <>
          <MDBox
            sx={{
              mt: 0.25,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              gap: 1,
            }}
          >
            <MDBox>
              <MDTypography fontWeight="bold">Ödeme tipi</MDTypography>
              <MDTypography variant="caption" sx={{ color: 'text.secondary' }}>
                Nakit / Kart / Havale
              </MDTypography>
            </MDBox>

            <ToggleButtonGroup
              value={otherMethod || 'CASH'}
              exclusive
              size="small"
              onChange={(e, val) => {
                if (val) setOtherMethod?.(val);
              }}
              sx={{
                height: 32,
                bgcolor: 'grey.100',
                borderRadius: 2,
                '& .MuiToggleButton-root': {
                  px: 1.25,
                  fontSize: 11,
                  textTransform: 'none',
                  borderRadius: 2,
                },
              }}
            >
              <ToggleButton value="CASH">Nakit</ToggleButton>
              <ToggleButton value="CARD">Kart</ToggleButton>
              <ToggleButton value="TRANSFER">Havale</ToggleButton>
            </ToggleButtonGroup>
          </MDBox>

          <Divider />
        </>
      ) : null}

      <MDInput
        value={otherAmountTry}
        onChange={(e) => setOtherAmountTry(e.target.value)}
        placeholder={`0 ${currencyLabel}`}
        fullWidth
        inputProps={{ inputMode: 'decimal' }}
      />

      <MDBox
        sx={{
          mt: 0.5,
          p: 1.25,
          borderRadius: '14px',
          border: `1px solid ${alpha(theme.palette.divider, 0.9)}`,
          background: alpha(theme.palette.background.paper, 0.6),
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          gap: 1,
        }}
      >
        <MDTypography variant="caption" sx={{ color: 'text.secondary' }}>
          {previewLabel}
        </MDTypography>
        <MDTypography fontWeight="bold">{moneyTRY(amount)}</MDTypography>
      </MDBox>

      {error ? (
        <MDBox
          sx={{
            mt: 0.25,
            p: 1,
            borderRadius: '12px',
            border: `1px solid ${alpha(theme.palette.error.main, 0.35)}`,
            background: alpha(theme.palette.error.main, 0.08),
          }}
        >
          <MDTypography variant="caption" sx={{ color: 'error.main' }}>
            {error}
          </MDTypography>
        </MDBox>
      ) : null}
    </MDBox>
  );
}
